import React, { Component } from "react";
import styles from "./inputEmail.module.css";
import TextField from "@material-ui/core/TextField";
import classnames from "classnames";
import { debounce } from "lodash";
import { isValidEmail } from "src/utils/field-validation";
import renderHTML from "html-react-parser";
import { _t } from "src/redux/store";

type Props = {
  name: string;
  value: string;
  label: string;
  info?: string;
  handleOnChange: Function;
  repeatedEmail?: string;
};

type State = {
  value: string;
  input: {
    isValid: boolean;
    warning: string;
  };
};

class InputEmail extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: "",
      input: {
        isValid: true,
        warning: "",
      },
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.value !== this.state.value) {
      this.debouncedHandleOnChange();
    }
  }

  debouncedHandleOnChange = debounce(() => {
    this.validateInput(this.state.value);
    if (this.state.input.isValid) {
      this.props.handleOnChange(this.props.name, this.state.value);
    } else {
      this.props.handleOnChange(this.props.name, "");
    }
  }, 200);

  handleOnChange = (newValue: string) => {
    this.setState({ value: newValue });
  };

  validateInput = (text: string) => {
    if (text.length > 5) {
      if (this.props.repeatedEmail && this.props.repeatedEmail !== this.state.value) {
        this.setState({
          input: {
            isValid: false,
            warning: _t.translate(
              "The emails don't match"
            ),
          },
        });
        return;
      }
      const isValid = isValidEmail(text);

      this.setState({
        input: {
          isValid: isValid,
          warning: _t.translate("Invalid email address"),
        },
      });
    } else {
      this.setState({
        input: {
          isValid: false,
          warning: _t.translate("Email address too small"),
        },
      });
    }
  };

  render() {
    return (
      <div className={styles.formControl}>
        <span className={styles.label}>{this.props.label}</span>
        <label className={styles.inputWrapper}>
          <TextField
            className={classnames(
              styles.textField,
              !this.state.input.isValid && styles.error
            )}
            onChange={(e) => this.handleOnChange(e.target.value)}
            value={this.state.value}
            InputProps={{
              className: styles.input,
              disableUnderline: true,
            }}
          />
        </label>
        {typeof this.props.info !== "undefined" && (
          <div className={styles.info}>{renderHTML(this.props.info)}</div>
        )}
        {!this.state.input.isValid && (
          <small className={styles.warning}>{this.state.input.warning}</small>
        )}
      </div>
    );
  }
}

export default InputEmail;
